export default __webpack_public_path__ + "static/8-35df946ebebd858b870f362b22217861.webp";